import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=02876818&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02876818",
  null
  
)

export default component.exports